import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";

interface State {
  error: Error | null;
}

export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Never include case values in automatic error output. React's component
    // stack contains component names only and is safe for local diagnostics.
    console.error("LogBookAnaes Studio render failure", error.name, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="fatal-error">
        <span className="empty-icon"><AlertTriangle size={23} /></span>
        <h1>Studio needs to reopen this workspace</h1>
        <p>No source file or clinical record was changed by this display error.</p>
        <button className="btn btn-primary" onClick={() => window.location.reload()} type="button"><RotateCcw size={15} /> Reload Studio</button>
      </main>
    );
  }
}
